import React from 'react'
import PropTypes from 'prop-types'
import { Badge, Col, Row } from 'reactstrap'
import {
  StyledExportButton,
} from './styles'
import FieldsetItem from '../../../components/FieldsetItem'
import FieldsetItemLarge from '../../../components/FieldsetItemLarge'

export const UserProfile = ({ 
  displayHSCompletionReportButton,
  displayK8CompletionReportButton,
  getLessonProgressReport, 
  productUser, 
 }) => {
  const lastLoggedInAtWithOffset = productUser.lastLoggedInAt + '-00:00'
  const lastLoggedInAtFormatted = new Date(
    lastLoggedInAtWithOffset,
  ).toLocaleString('en-US', {
    timeZoneName: 'short',
  })
  const lastLoggedIn =
    lastLoggedInAtFormatted !== 'Invalid Date' ? lastLoggedInAtFormatted : ''

  return (
    <React.Fragment>
      <Col sm={8}>
        <fieldset>
          <legend>Profile</legend>
          <Row>
            <Col>
              <Row>
                <Col>
                  <FieldsetItem
                    data={productUser.firstName || '-'}
                    title="First Name"
                  />
                </Col>
                <Col>
                  <FieldsetItem
                    data={productUser.lastName || '-'}
                    title="Last Name"
                  />
                </Col>
                <Col>
                  <FieldsetItem data={productUser.email || '-'} title="Email" />
                </Col>
              </Row>
              <FieldsetItem
                data={productUser.contactPhoneNumber || '-'}
                title="Contact Number"
              />
              <FieldsetItem
                data={productUser.mobilePhoneNumber || '-'}
                title="Mobile Phone"
              />
            </Col>
            <Col>
              <FieldsetItem data={productUser.siteId} title="Site Id" />
              <FieldsetItemLarge
                data={productUser.siteName}
                title="School Name"
              />
              <FieldsetItem data={productUser.title || '-'} title="Job Title" />
            </Col>
          </Row>
        </fieldset>
      </Col>
      <Col>
        <fieldset>
          <legend>Other</legend>
          <FieldsetItem title="Is Setup Admin">
            {productUser.roles.includes('Set-Up Admin') ? (
              <Tag color="info" text="Yes" />
            ) : (
              <Tag color="light" text="No" />
            )}
          </FieldsetItem>
          <FieldsetItem title="Is SSO User">
            {productUser.isSSO ? (
              <Tag color="warning" text="Yes" />
            ) : (
              <Tag color="light" text="No" />
            )}
          </FieldsetItem>
          <FieldsetItem data={lastLoggedIn} title="Last Login" />
          { displayK8CompletionReportButton &&
            <StyledExportButton
              data-testid="k8-report-export-button"
              color="primary"
              role="button"
              size="sm"
              onClick={() => getLessonProgressReport('K8')}
            >
              Export K8 Lesson Progress Report
            </StyledExportButton>
          }
          { displayHSCompletionReportButton &&
            <StyledExportButton
              data-testid="hs-report-export-button"
              color="primary"
              role="button"
              size="sm"
              onClick={() => getLessonProgressReport('HS')}
            >
              Export HS Lesson Progress Report
            </StyledExportButton>
          }
        </fieldset>
      </Col>
    </React.Fragment>
  )
}

UserProfile.propTypes = {
  displayHSCompletionReportButton: PropTypes.bool,
  displayK8CompletionReportButton: PropTypes.bool,
  getLessonProgressReport: PropTypes.func.isRequired,
  productUser: PropTypes.object.isRequired,
}

const Tag = ({ color, text }) => (
  <Badge color={color} key={text} style={{ fontSize: 'initial' }}>
    {text}
  </Badge>
)

Tag.propTypes = {
  color: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

export default UserProfile



// WEBPACK FOOTER //
// ./src/containers/css-admin/users/UserProfile.js